import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import GenerateLinkContent from './GenerateLinkContent';
import {useTranslation} from 'react-i18next';

interface Props {
    open: boolean;
    onClose: () => void;
    profileId?: string;
    sectorId?: string;
}

export default function GenerateLinkDialog({open, onClose, profileId, sectorId}: Props) {
    const {t} = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>{t('Generate Form Link with Profile')}</DialogTitle>
            <DialogContent>
                <GenerateLinkContent
                    profileId={profileId}
                    sectorId={sectorId}
                    enabled={open}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {t('Close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
